<template>
	<div class="childDiv2" id="page9" ref="mainEl" page="3">
		<div class="childWrapper">
			<div class="relative h-[216.5px] top-[210px] left-[90px] flex items-center">
				<img alt="" src="images/1x_images/section2/page3/text-keyingredients.png" srcset="images/2x_images/section2/page3/text-keyingredients.png 2x" class="relative" />
			</div>
			<div class="relative top-[260px] w-full pointer-events-auto">
				<div class="w-full relative top-[-25px]">
					<Carousel :images="serumImages" :top="30" :spaceBetween="-20" ref="carouselEl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import Carousel from "../../components/Carousel.vue";

export default {
	name: "page-1",
	components: { Carousel },
	data() {
		return {
			serumImages: ["section2/page3/serum-panel-2.png", "section2/page3/serum-panel-3.png"],
		};
	},
	methods: {
		start() {},
		stop() {
			this.reset();
		},
		reset() {
			this.$refs.carouselEl.reset();
		},
	},
	mounted() {},
};
</script>

<style scoped></style>
